import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import { StyledSwitcher, SwitcherButton } from './Switcher.styles';

function Switcher({ data, onClick }) {
  const [isActiveState, setisActiveState] = useState(true);

  const onClickHandler = useCallback(value => {
    onClick(value);
    setisActiveState(value);
  });

  if (!Object.entries(data).length) return null;

  return (
    <StyledSwitcher lighterBg={!isActiveState}>
      {data.liked && (
        <SwitcherButton type="button" active={isActiveState} onClick={() => onClickHandler(true)}>
          {data.liked.text}
        </SwitcherButton>
      )}
      {data.boards && (
        <SwitcherButton type="button" active={!isActiveState} onClick={() => onClickHandler(false)}>
          {data.boards.text}
        </SwitcherButton>
      )}
    </StyledSwitcher>
  );
}

Switcher.propTypes = {
  data: PropTypes.shape({
    liked: PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string,
    }),
    boards: PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string,
    }),
  }),
  onClick: PropTypes.func,
};

Switcher.defaultProps = {
  data: {},
  onClick: () => {},
};

export default Switcher;
